export default __webpack_public_path__ + "static/media/EAST0570.34I-29073_-16953_0.b6ab0cdf.jpg";